export default {
  top: {
    forms: [
      {
        url: 'https://sphinxdeclic.com/tiny/a/kzejf6t4',
        title: 'Fiche Service',
        id: 'service',
        text: `Formulaire contenant les données concernant votre établissement et le service
participant.`,
        icon: 'hospital-1',
        style: 'techSheet'
      },
      {
        url: 'https://sphinxdeclic.com/tiny/a/yj548mn6',
        title: 'Fiches Maintien du CVP',
        id: 'maintien',
        text: `Formulaire contenant les 5 fiches d'évaluation de la surveillance quotidienne
               et de la pertinence du maintien du dispositif. <br><br><strong>Les 5 fiches sont
               à remplir en une seule fois.</strong>`,
        icon: 'dropper',
        style: 'expADI'
      },
      {
        url: 'https://sphinxdeclic.com/tiny/a/hmxgqnyg',
        title: 'Fiche Patient Bactériémique',
        id: 'patient',
        text: `Formulaire contenant des informations complémentaires sur un patient
bactériémique.<br><br> <strong>À remplir autant de fois que de patients ayant
présenté une bactériémie liée à un CVP court pendant la période de surveillance,
quel que soit le germe en cause.</strong>`,
        icon: 'medical-report',
        style: 'bactADI'
      }
    ],
    files: [
      {
        title: 'Guide Technique',
        icon: 'guide',
        text: 'Version 2 - 25/03/2025',
        link: 'documents/topCvp/SPIADI2025 - TOP CVP - Guide Technique (Version 2).pdf',
        description: 'SPIADI2025 - TOP CVP - Guide Technique (Version 2).pdf'
      },
      {
        title: 'Fiche Service',
        icon: 'hospital-1',
        text: 'Version 2 - 25/03/2025',
        link: 'documents/topCvp/SPIADI2025 - TOP CVP - Fiche Service (Version 2).pdf',
        description: 'SPIADI2025 - TOP CVP - Fiche Service (Version 2).pdf'
      },
      {
        title: 'Fiche Maintien du CVP',
        icon: 'dropper',
        text: 'Version 1 - 20/12/2024',
        link: 'documents/topCvp/SPIADI2025 - TOP CVP - Fiche Maintien du CVP.pdf',
        description: 'SPIADI2025 - TOP CVP - Fiche Maintien du CVP.pdf'
      },
      {
        title: 'Fiche Patient Bactériémique',
        icon: 'medical-report',
        text: 'Version 1 - 20/12/2024',
        link: 'documents/topCvp/SPIADI2025 - TOP CVP - Fiche Patient Bactériémique.pdf',
        description: 'SPIADI2025 - TOP CVP - Fiche Patient Bactériémique.pdf'
      },
      {
        title: 'Aide à la saisie de la Fiche Service',
        icon: 'csv',
        text: 'Version 2 - 01/04/2025',
        link: 'documents/topCvp/SPIADI2025 - TOP CVP - Aide à la saisie de la Fiche Service (Version 2).xlsx',
        description: 'SPIADI2025 - TOP CVP - Aide à la saisie de la Fiche Service (Version 2).xlsx'
      }
    ],
    hfb: [
      {
        title: `Inscription en ligne à partir de votre espace SPIADI`,
        texts: [
          `En utilisant l'encart «Recherche» sur l'accueil de votre établissement.`
        ],

        icon: 'registration',
        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Participation possible dans tous les types de services`,
        texts: [
          `Plusieurs services d'un même établissement peuvent participer.`
        ],
        icon: 'hospital',
        separator: {
          icon: 'triangle-bottom',
          style: 'fontSize: 300%;',
          hr: true
        }
      },
      {
        title: `Surveillance des bactériémies dans le service participant`,
        texts: [
          `Participation à la surveillance SPIADI pendant 3 mois en utilisant l'une
des cinq modalités de surveillance : <span class='label label-bactADI'>Bact ADI+</span>,
<span class='label label-expADI'>Exp ADI</span>, <span class='label label-reaInfADI'>Réa Inf ADI</span>,
<span class='label label-diaInfADI'>Dia Inf ADI</span> ou <span class='label label-neoInfADI'>Néo Inf ADI</span>.`
        ],

        icon: 'event',
        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Observation des pratiques dans le service participant`,
        texts: [
          `Utilisation du module <span class='label label-observa4'>
Observa4</span>.`,
          `5 poses de CVP et 5 manipulations de lignes de CVP.`
        ],

        icon: 'medical-history-1',
        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Évaluation de la surveillance quotidienne et de la pertinence du maintien dans le service participant`,
        texts: [
          `Pour 5 porteurs de CVP de plus de 24h.`
        ],

        icon: 'dropper',
        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Collecte de données 2024 de ressources humaines du service participant`,
        texts: [
        ],

        icon: 'doctor',
        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Étude des patients du service ainsi que leur exposition aux CVPs`,
        texts: [
          `Collecte de données patients un jour donné.`,
          `Collecte du nombre de CVP (avec ou sans prolongateur) commandés à la pharmacie en 2024.`
        ],

        icon: 'name',
        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Étude des mesures de prévention mises en oeuvre pour les patients bactériémiques`,
        texts: [
          `Une fiche par patient ayant acquis une B-CVP pendant la période de surveillance,
décrivant les mesures mises en oeuvre pour ce patient.`
        ],

        icon: 'repair',

        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },
      {
        title: `Envoi des souches de <i>Staphylococcus aureus</i> pour les bactériémies sur CVP
impliquant ce pathogène`,
        texts: [
        ],

        icon: 'swabs',

        separator: {
          icon: 'triangle-bottom',
          style: 'fontSize: 300%;',
          hr: true
        }
      },

      {
        title: `Analyse des données par l'équipe SPIADI`,
        texts: [
          `Ensemble des données à envoyer avant le <strong>15 juillet 2025</strong> afin de
permettre une analyse statistique poussée.`
        ],
        icon: 'analytics',
        separator: {
          icon: 'plus',
          style: 'fontSize: 180%; margin-bottom: 1rem;'
        }
      },

      {
        title: `Étude microbiologique des souches de <i>S. aureus</i>
responsables de bactériémies associées aux soins`,
        icon: 'petri-dish',
        texts: [
          `Séquençage du génome entier pour étudier la virulence, la sensibilité aux
antibiotiques et antiseptiques et la capacité à produire du biofilm.`
        ],
        separator: {
          icon: 'triangle-bottom',
          style: 'fontSize: 300%;',
          hr: true
        }

      },
      {
        title: `Résultats le 2 Octobre 2025`,
        texts: [
          `Les résultats de l’étude seront restitués lors de la septième journée nationale
de la SPIADI le 2 octobre 2025 et feront l’objet d’une communication dans un
congrès national et/ou une publication scientifique dans une revue avec comité
de lecture.<br><br>Tous les participants seront cités nommément.`
        ],
        icon: 'analytics-1'
      }
    ]
  }
}
